import { createSingleEntityStore, ngrxEvent } from '@core/ngrx-legacy';

import type {
  OfferContentGeneratorRequest,
  OfferContentGeneratorResponse,
} from './offer-content-generator.types';
import { EntityStoreKey } from '../../types';

const { actions, selectors, reducer, namespace } =
  createSingleEntityStore<OfferContentGeneratorResponse>()(EntityStoreKey.OfferContentGenerator, {
    customActions: adapter => ({
      fetch: (state, _payload: OfferContentGeneratorRequest) => adapter.markAsPending(state),
      fetchEventStream: (state, _payload: OfferContentGeneratorRequest) =>
        adapter.markAsPending(state),
      updateEventStream: (state, payload: OfferContentGeneratorResponse) =>
        adapter.update(state, payload),
      fetchEventStreamAbort: ngrxEvent<void>(),
      fetchEventSuccess: state => adapter.markAsLoaded(state),
      fetchEventFailed: (state, err: string) => adapter.setError(state, Error(err)),
    }),
  });

export {
  actions as OfferContentGeneratorActions,
  selectors as OfferContentGeneratorSelectors,
  reducer as OfferContentGeneratorReducer,
  namespace as OfferContentGeneratorNamespace,
};
